/* FARTS.com · the header on every page except the home page (product, cart, search, policies, 404...).
   The home page runs the full site script instead (farts.js). */
(function () {
  'use strict';
  var $ = function (s) { return document.querySelector(s); };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // phone menu: "More" opens every section link
  var btn = $('#moreBtn'), menu = $('#moreMenu');
  if (btn && menu) {
    var set = function (open) { menu.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false'); };
    btn.addEventListener('click', function (e) { e.stopPropagation(); set(menu.hidden); });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
    document.addEventListener('click', function (e) { if (!menu.hidden && !menu.contains(e.target) && !btn.contains(e.target)) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) { set(false); btn.focus(); } });
  }

  // the cart button opens the cart page and shows how many items are in it
  var cart = $('#cartBtn'), count = $('#cartCount');
  if (cart) {
    cart.addEventListener('click', function () { location.href = root + 'cart'; });
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = c.item_count || 0;
        if (count) count.textContent = n;
        cart.classList.toggle('has', n > 0);
        cart.setAttribute('aria-label', n ? 'Open cart, ' + n + (n === 1 ? ' item' : ' items') : 'Open cart');
      })
      .catch(function () {});
  }

  // the phone buy bar and the cart drawer belong to the home page
  var bar = $('#buyBar'); if (bar) bar.style.display = 'none';
})();
